import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import WPInvoiceManagementTable from "./table"

const WPInvoiceManagement = () => {
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Invoices"} />
          <WPInvoiceManagementTable />
        </Container>
      </div>
    </>
  )
}

export default WPInvoiceManagement
